import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const updateUserRating = async ({ action, stars, message }) => {
  try {
    const response = await client.patch("/users/rating", {
      action,
      stars,
      message,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
